










































































import { Component, Prop, Inject, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import insertText from "insert-text-textarea";
import { getModule } from "vuex-module-decorators";
import autosize from "v-autosize";

import FormField from "@/lib/components/FormField.vue";
import FormErrors from "@/lib/components/FormErrors.vue";
import MessageAttachmentUpload from "@/modules/messaging/components/MessageSendingForm/AttachmentUpload.vue";
import SubmitButton from "@/lib/components/SubmitButton.vue";
import MessagesSendingFormEmojiPicker from "@/modules/messaging/components/EmojiPicker.vue";

import getAttachmentThumbnail from "@/modules/messaging/get-attachment-thumbnail.function";
import preloadImage from "@/lib/preload-image.function";
import autoindent from "@/lib/directives/auto-indent.directive";
import GeneralFormMixin from "@/lib/mixins/GeneralForm";
import AuthenticatedUserProvider from "@/modules/account/authenticated-user-provider.service";
import ImageHandlerService from "@/modules/file-storage/image-handler.service";
import IdGenerator from "@/lib/services/id-generator";
import Item from "@/modules/file-storage/item.model";
import dataStore from "@/store";

import CustomerPreviewStore from "../../store";

@Component({
  components: {
    FormField,
    FormErrors,
    MessageAttachmentUpload,
    SubmitButton,
    MessagesSendingFormEmojiPicker,
  },
  directives: {
    autoindent,
    autosize,
  },
})
export default class RejectionForm extends mixins(GeneralFormMixin) {
  @Prop({ required: true })
  public readonly plushieId!: string;

  @Inject("AuthenticatedUserProvider")
  private userProvider!: AuthenticatedUserProvider;

  @Inject("IdGenerator")
  private idGenerator!: IdGenerator;

  @Inject("ImageHandlerService")
  private imageHandlerService!: ImageHandlerService;

  private fCustomerPreviewDataStore: CustomerPreviewStore;

  public comment?: string;
  public agreement?: boolean;

  private attachmentStorageItemIds: string[] = [];
  private fIsAttachmentsProcessingInProgress = false;
  private fIsLoading = true;

  get isAttachmentsProcessingInProgress() {
    return this.fIsAttachmentsProcessingInProgress;
  }

  get isDisabled() {
    return (
      this.isAttachmentsProcessingInProgress || this.fIsDisabled || this.disable
    );
  }

  get isUploadDisabled() {
    return this.fIsDisabled || this.disable;
  }

  constructor() {
    super();
    this.fCustomerPreviewDataStore = getModule(CustomerPreviewStore, dataStore);
  }

  browseFiles() {
    const attachmentUpload = this.getAttachmentUpload();
    if (!attachmentUpload) {
      return;
    }

    attachmentUpload.browseFiles();
  }

  onEmojiPicked(emoji: string): void {
    const messageInput = this.getMessageInput();

    if (!messageInput) {
      return;
    }

    messageInput.focus();

    insertText(messageInput, emoji);
  }

  public onAttachmentAdded(storageItem: Item): void {
    this.attachmentStorageItemIds.push(storageItem.id);

    const thumbUrl = getAttachmentThumbnail(
      storageItem.url,
      this.imageHandlerService
    );

    void preloadImage(thumbUrl);
  }

  public onAttachmentRemoved(storageItemId: string): void {
    const index = this.attachmentStorageItemIds.indexOf(storageItemId, 0);

    if (index > -1) {
      this.attachmentStorageItemIds.splice(index, 1);
    }
  }

  public onAttachmentIsBusyChanged(value: boolean): void {
    this.fIsAttachmentsProcessingInProgress = value;
  }

  protected async afterSubmit(): Promise<void> {
    this.$nextTick(() => {
      const messageInput = this.getMessageInput();
      if (!messageInput) {
        return;
      }

      messageInput.focus();
    });
  }

  protected data() {
    return {
      comment: this.comment,
      agreement: this.agreement,
    };
  }

  protected async performSubmit(): Promise<void> {
    if (!this.comment || !this.agreement) {
      return;
    }

    await this.fCustomerPreviewDataStore.createCustomerPreviewRejection({
      plushieId: this.plushieId,
      comment: this.comment,
      attachments: this.attachmentStorageItemIds,
    });

    await this.$router.push({
      name: "RejectSuccessPage",
    });
  }

  private getAttachmentUpload(): MessageAttachmentUpload | undefined {
    return this.$refs["attachment-upload"] as MessageAttachmentUpload;
  }

  private getMessageInput(): HTMLTextAreaElement | undefined {
    return this.$refs["comment-input"] as HTMLTextAreaElement;
  }

  @Watch("plushieId", { immediate: true })
  private async onPlushieIdChange(): Promise<void> {
    this.attachmentStorageItemIds = [];
    this.comment = "";

    const attachmentUpload = this.getAttachmentUpload();

    if (!attachmentUpload) {
      return;
    }

    attachmentUpload.clearInput();
  }
}
